///////////////////////////////////////////////
//           Contdown styling                //
///////////////////////////////////////////////

@import './pk-countdown.variables';

:host {
  @apply inline-flex;
}

.countdown--container {
  font-family: var(--countdown--font-family);
}

.countdown--container__heading {
  ::slotted(*) {
    @apply m-0 mb-[--pk-spacing-s] p-0 font-inherit text-[length:--countdown--font-size--heading] text-[color:--countdown--color-heading];
  }
}
